import _ from "lodash";
import moment from "moment-timezone";

import { scheduleRequests } from "@/api/(requests)/schedule";

export const getScheduleForToday = async (showLoader = false) => {
  const format = "YYYY-MM-DD HH:mm";

  return scheduleRequests.get_schedule({
    context: { showLoader },
    searchParams: {
      local_end_date_time: moment().endOf("day").format(format),
      local_start_date_time: moment().startOf("day").format(format),
      timezone: moment.tz.guess(),
    },
  });
};

export const isCareTeamRestricted = (providerType, patientDetails) => {
  if (!patientDetails.is_wait_listed) {
    return false;
  }
  const relevantProviderTypesMap = {
    "Behavioral Specialist": "BEHAVIORAL",
    "Intake Behavioral Specialist": "BEHAVIORAL_INTAKE",
    Prescriber: "PRESCRIBE",
  };

  const wait_list_no_longer_schedule_with_roles = _.get(
    patientDetails,
    "wait_list_no_longer_schedule_with_roles",
    undefined,
  );

  if (wait_list_no_longer_schedule_with_roles === undefined) {
    return true;
  }

  return relevantProviderTypesMap[providerType]
    ? wait_list_no_longer_schedule_with_roles.includes(relevantProviderTypesMap[providerType])
    : true;
};
